import bg from '../assets/bg.webp';
import chef from '../assets/chef.webp';
import G from '../assets/G.png';
import gallery01 from '../assets/gallery01.webp';
import gallery02 from '../assets/gallery02.webp';
import gallery03 from '../assets/gallery03.webp';
import gallery04 from '../assets/gallery04.webp';
import knife from '../assets/knife.webp';
import menu from '../assets/menu.webp';
import overlaybg from '../assets/overlaybg.webp';
import spoon from '../assets/spoon.svg';
import welcome from '../assets/welcome.webp';
import findus from '../assets/findus.webp';
import laurels from '../assets/laurels.webp';
import award01 from '../assets/award01.png';
import award02 from '../assets/award02.png';
import award03 from '../assets/award03.png';
import award05 from '../assets/award05.png';
import sign from '../assets/sign.png';
import quote from '../assets/quote.png';
import foodiverse from '../assets/foodiverse.png';

export default {
  bg,
  chef,
  G,
  gallery01,
  gallery02,
  gallery03,
  gallery04,
  knife,
  menu,
  overlaybg,
  spoon,
  welcome,
  findus,
  laurels,
  award01,
  award02,
  award03,
  award05,
  sign,
  quote,
  foodiverse,
};
